import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsContactAdministratorRoute: InvariantJiraRoute = {
	name: 'global-settings-contact-administrator',
	path: '/jira/contact-administrator',
};
